var map = {
	"./Articles/Index": [
		5685,
		685
	],
	"./Articles/Index.vue": [
		5685,
		685
	],
	"./Articles/Show": [
		2580,
		580
	],
	"./Articles/Show.vue": [
		2580,
		580
	],
	"./Contact": [
		9734,
		26
	],
	"./Contact.vue": [
		9734,
		26
	],
	"./DueDiligence": [
		1343,
		343
	],
	"./DueDiligence.vue": [
		1343,
		343
	],
	"./Group": [
		7061,
		61
	],
	"./Group.vue": [
		7061,
		61
	],
	"./Home": [
		9703,
		703
	],
	"./Home.vue": [
		9703,
		703
	],
	"./Legal": [
		9666,
		666
	],
	"./Legal.vue": [
		9666,
		666
	],
	"./Methodology": [
		2708,
		708
	],
	"./Methodology.vue": [
		2708,
		708
	],
	"./Services": [
		830,
		830
	],
	"./Services.vue": [
		830,
		830
	],
	"./Team": [
		1540,
		540
	],
	"./Team.vue": [
		1540,
		540
	],
	"./Testimonials": [
		7883,
		883
	],
	"./Testimonials.vue": [
		7883,
		883
	],
	"./Workflow": [
		7904,
		904
	],
	"./Workflow.vue": [
		7904,
		904
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4985;
module.exports = webpackAsyncContext;